import Image from 'next/image';
import { motion } from 'framer-motion';
import { XumoButton } from 'ui';

// interface NascarRisingBannerProps {
//   mobileBgSrc: string;
//   appIconSrc: string;
//   desktopBgSrc: string;
//   logoLockupSrc: string;
//   headingLine1: string;
//   headingLine2: string;
//   description: string;
//   primaryButtonText: string;
//   primaryButtonHref: string;
//   secondaryButtonText?: string;
//   secondaryButtonHref?: string;
// }

// // mobileBgSrc="/static/images/refresh/2026/nascar/nascar-bg-mobile.webp"
// // desktopBgSrc="/static/images/refresh/2026/nascar/nascar-bg-desktop.webp"
// // appIconSrc="/static/images/refresh/2026/nascar/xp-app.webp"
// // logoLockupSrc="/static/images/refresh/2026/nascar/nascar-rising-lockup.png"
// // headingLine1="Raw talent."
// // headingLine2="real access."
// // description="Stream NASCAR® RISING season 2 only on Xumo Play this August."
// // primaryButtonText="Watch season 1 now"
// // primaryButtonHref="https://play.xumo.com/tv-shows/nascar-channel/XM0TO5J03S6JQ1"
// // secondaryButtonText="Learn more"
// // secondaryButtonHref="https://www.nascar.com/news-media/2026/06/23/nascar-studios-words-pictures-partner-for-season-2-of-rising-exclusively-on-xumo-play/"

// const NascarRisingBanner = ({
//   mobileBgSrc,
//   appIconSrc,
//   desktopBgSrc,
//   logoLockupSrc,
//   headingLine1,
//   headingLine2,
//   description,
//   primaryButtonText,
//   primaryButtonHref,
//   secondaryButtonText,
//   secondaryButtonHref,
// }: NascarRisingBannerProps) => {
//   return (
//     <section className="relative mx-auto flex w-full items-center justify-center bg-black text-white">
//       {/* Image with text over */}
//       <div className="z-10 flex w-full max-w-[2048px] flex-col flex-col-reverse overflow-hidden lg:h-[622px] lg:flex-row">
//         {/* Content LEFT */}
//         <div className="flex w-full flex-col gap-6 bg-[url('/static/images/refresh/2026/nascar/nascar-mobile-chevron.webp')] bg-cover bg-bottom px-8 py-12 lg:min-h-0 lg:w-1/2 lg:gap-7 lg:bg-none lg:px-0 lg:pb-10 lg:pl-4 lg:pt-16 xl:pl-16 2xl:pl-24">
//           {/* Heading */}
//           <h2 className="max-w-[330px] text-[72px] font-black uppercase leading-[86%] tracking-[0] md:max-w-none lg:text-[66px] xl:text-[72px] 2xl:text-[82px]">
//             {headingLine1}
//             <br />
//             {headingLine2}
//           </h2>

//           {/* Description */}
//           <p
//             className="max-w-[290px] pr-8 text-[20px] font-bold leading-[95%] tracking-[0px] md:max-w-[488px] md:text-[22px]"
//             aria-label="Stream NASCAR Rising season 2 only on Xumo Play this August."
//           >
//             {description}
//           </p>

//           {/* CTAs */}
//           <div className="flex flex-col flex-wrap gap-6 md:flex-row xl:gap-10">
//             <XumoButton href={primaryButtonHref} light primary alignment="self-start" className="rounded-lg text-base lg:text-lg">
//               {primaryButtonText}
//             </XumoButton>
//             {secondaryButtonText && (
//               <XumoButton href={secondaryButtonHref ?? ''} target="_blank" light primary alignment="self-start" className="rounded-lg text-base lg:text-lg">
//                 {secondaryButtonText}
//               </XumoButton>
//             )}
//           </div>

//           {/* Xumo Play Tile */}
//           <div className="mt-12 flex items-center gap-5 lg:mt-auto">
//             <Image src={appIconSrc} alt="Xumo Play" width={146} height={146} priority className="w-24" />

//             <p className="text-[20px] font-bold uppercase tracking-[0] text-white">Stream free</p>
//           </div>
//         </div>

//         {/* Content RIGHT (TOP on mobile) */}
//         <div className="flex min-h-[383px] w-full items-end justify-center bg-[url('/static/images/refresh/2026/nascar/nascar-mobile-keyart.webp')] bg-cover bg-bottom pb-8 text-white lg:min-h-0 lg:w-1/2 lg:bg-none">
//           <div className="relative h-[94px] w-[250px] sm:h-[140px] sm:w-[380px] lg:h-[211px] lg:w-[560px]">
//             <Image src={logoLockupSrc} alt="NASCAR Rising" fill className="object-contain" />
//           </div>
//         </div>

//         {/* Desktop BG Image */}
//         <div className="absolute inset-0 -z-10 flex h-full w-full overflow-hidden">
//           {/* Desktop */}
//           <Image src={desktopBgSrc} alt="" width={2048} height={622} priority className="mx-auto hidden h-full w-screen max-w-[2048px] object-cover lg:block" />
//         </div>
//       </div>

//       {/* Dradient overlay */}
//       <motion.div
//         initial={{ opacity: 0, marginTop: 30 }}
//         animate={{ opacity: 1, marginTop: 0 }}
//         transition={{ delay: 0.75, ease: [0, 1, 1, 1], duration: 0.9, deltaRest: 0.00001, deltaSpeed: 0.00001 }}
//       >
//         <div
//           style={{
//             display: 'none',
//           }}
//           className="pointer-events-none absolute left-1/2 top-0 z-40 mx-auto h-full w-[2048px] -translate-x-1/2"
//           aria-hidden
//         >
//           <style jsx>{`
//             @media (min-width: 2048px) {
//               div[aria-hidden] {
//                 display: block !important;
//               }
//             }
//           `}</style>{' '}
//           <div className="pointer-events-none absolute left-0 top-0 h-full w-[100px] bg-gradient-to-r from-black via-black/40 to-transparent" />
//           <div className="pointer-events-none absolute right-0 top-0 h-full w-[100px] bg-gradient-to-l from-black via-black/40 to-transparent" />
//         </div>
//       </motion.div>
//     </section>
//   );
// };

export const NascarBanner = () => {
  return (
    <section className="flex h-full w-full flex-col items-center justify-center bg-[linear-gradient(249deg,_#64325A_25.35%,_#190A19_89.76%)] text-white lg:flex-row">
      {/* Copy */}
      <div className="flex flex-col items-center justify-center gap-6 px-10 pb-10 pt-8 lg:w-[500px] xl:w-[650px] xl:pb-12 xl:pt-10 min-[2000px]:w-1/2">
        {/* Title & Icon */}
        <Image src="/static/images/refresh/2026/nascar/two-flags.svg" alt="Two Flags Icon" width={100} height={100} className="w-14 sm:w-16" />
        <h2 className="text-center text-3xl font-light leading-[35px] -tracking-[1px] sm:text-4xl xl:text-[52px]">
          Fans win with <span className="font-medium">Xumo</span>
        </h2>
        <p className="mt-1 max-w-[395px] text-center text-base font-light leading-tight tracking-[1px] sm:text-lg xl:max-w-[465px] xl:text-xl">
          Enter for chances to win exclusive experiences, tickets, prizes, and more.
        </p>
        {/* Button */}
        <XumoButton href="/sweepstakes" light primary color="xumoBerry" className="rounded-lg text-base font-bold lg:text-lg" padding="px-10 py-2.5">
          See all sweepstakes
        </XumoButton>
      </div>
      {/* Image */}
      <div className="h-[400px] w-full bg-[url('/static/images/refresh/2026/nascar/enter-to-win-img.jpg')] bg-cover bg-[position:41%_10%] bg-no-repeat sm:h-[500px] md:aspect-[2/1] lg:aspect-auto lg:h-[480px] lg:w-auto lg:flex-1 xl:h-[530px]"></div>
    </section>
  );
};
